export default {"src":"/_next/static/media/live-circle.c9d498a0.gif","height":269,"width":269};